import Events from '@utilities/events'

const JS_HOOK_MESSAGE = '[js-hook-message]'
const JS_HOOK_CONTENT = '[js-hook-alert-content]'

/**
 * Add alert message to page
 *
 * @param {String} message -  the message string to show
 * @param {String} hook - [js-hook-message] or custom hook
 * @param {String} type - success, warning or error type
 */
const addAlertMessage = function ({ message, hook, type, scroll = false }) {
  const selector = hook || JS_HOOK_MESSAGE
  const status = type || 'error'

  const el = document.querySelector(selector)

  if (!el) return
  const content = el.querySelector(JS_HOOK_CONTENT)
  content.innerHTML = message

  // Add classes and show
  const variantClass = `alert--${status}`;
  el.className = el.className.replace(/(?:^|\W)alert--(\w+)(?!\w)/g, ` ${variantClass}`)
  if(!el.classList.contains(variantClass)) el.classList.add(variantClass)
  el.classList.remove('u-hidden')
  el.removeAttribute('aria-hidden')
  el.focus()

  // Scroll to alert
  if (!el.classList.contains('is--relative') && !scroll) return
  Events.$trigger('scroll-to::scroll', {
    data: {
      target: el,
      offset: 130,
    },
  })
}
export default addAlertMessage
